<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <b-row>
                    <b-col>
                        <b-alert :show="feedback.show"
                                 dismissible
                                 :variant="feedback.variant"
                                 @dismissed="feedback.show=0"
                                 @dismiss-count-down="countDownChanged">
                            {{feedback.text}}
                            <ul v-if="errors" class="mt-3">
                                <li v-for="error in errors">{{error.toString()}}</li>
                            </ul>
                        </b-alert>
                        <b-card>
                            <template slot="header">
                                <span class="pull-left mt-2">{{item.name}}</span>
                                <b-button @click="editable = true" class="pull-right" variant="primary" v-if="!editable">Bewerk</b-button>
                            </template>
                            <b-form @submit.prevent="saveItem">
                                <b-row>
                                    <b-col cols="12" md="6">
                                        <b-form-group label="Naam">
                                            <b-form-input type="text" required v-model="item.name" :disabled="!editable"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <b-form-group label="Email">
                                            <b-form-input type="email" required v-model="item.email" :disabled="!editable"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" v-if="editable">
                                        <b-form-group label="Huidig wachtwoord (verplicht)">
                                            <b-form-input type="password" required v-model="item.password" :disabled="!editable"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" v-if="editable">
                                        <b-form-group label="Nieuw wachtwoord (optioneel)">
                                            <b-form-input type="password" v-model="item.new_password" :disabled="!editable"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" v-if="editable">
                                        <b-form-group label="Nieuw wachtwoord bevestiging (optioneel)">
                                            <b-form-input type="password" v-model="item.new_password_confirmation" :disabled="!editable"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-button type="submit" variant="success" class="pull-right" v-if="editable" :disabled="saveButtonDisabled">Opslaan</b-button>
                                        <b-button @click="cancelEdit" class="pull-right mr-2" variant="warning" v-if="editable">Annuleer</b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import {updateData, getData} from '../../api';

    export default {
        name: 'profile',
        props: ['id'],
        data () {
            return {
                saveButtonDisabled: false,
                feedback: {
                    show: false,
                    text: '',
                    variant: null,
                    dismissCountDown: 4
                },
                errors: null,
                editable: false,
                companyOptions: [],
                locationOptions: [],
                item: {},
            }
        },
        methods: {
            async getItem() {
                const item = await getData('profile').then(response => response.data);
                this.item = item.data;
            },
            async saveItem() {
                this.errors = null;
                this.saveButtonDisabled = true;
                const request = await updateData('profile', this.item);
                if(request.status === 200) {
                    this.feedback.show = true;
                    this.feedback.text = 'Gebruiker succesvol geupdate';
                    this.feedback.variant = 'success';
                    this.editable = false;
                    this.saveButtonDisabled = false;
                    this.getItem();
                } else {
                    this.errors = request.data.errors;
                    this.feedback.show = true;
                    this.feedback.text = 'Er is iets mis...';
                    this.feedback.variant = 'danger';
                    this.editable = true;
                    this.saveButtonDisabled = false;
                }
            },
            cancelEdit() {
                this.editable = false;
                this.getItem();
            },
            countDownChanged (dismissCountDown) {
                this.feedback.dismissCountDown = dismissCountDown
            },
            showAlert () {
                this.this.feedback.dismissCountDown = this.dismissSecs
            }
        },
        computed: {
            userRole () {
                return this.$store.state.userRole
            }
        },
        beforeMount() {
            this.getItem();
            this.getCompanyOptions();
            this.getLocationOptions();
        },

    }
</script>
